import keyword_search_widget_0 from "file:///home/wldocker/wl-cms/sites/modules/keyword-search-widget/ui/src/keyword-search-widget.js";



import keyword_search_widget_0Stylesheet from "file:///home/wldocker/wl-cms/sites/modules/keyword-search-widget/ui/src/keyword-search-widget.scss";keyword_search_widget_0();